import React, { useRef, useState } from 'react';
import '../ConfirmationPopup/ConfirmationPopup.css'; // Optional: for custom styling
import {servicesManager} from "../../../../app/src/App"
function SignaturePad({ title, message, onConfirm, onCancel, isOpen }) {
  const canvasRef = useRef(null);
  const { uiNotificationService } = servicesManager.services;

  const [isDrawing, setIsDrawing] = useState(false);

  const startDrawing = ({ nativeEvent }) => {
      const ctx = canvasRef.current.getContext('2d');
      ctx.beginPath();
      ctx.moveTo(nativeEvent.offsetX, nativeEvent.offsetY);
      setIsDrawing(true);
  };

  const draw = ({ nativeEvent }) => {
      if (!isDrawing) return;
      const ctx = canvasRef.current.getContext('2d');
      ctx.lineTo(nativeEvent.offsetX, nativeEvent.offsetY);
      ctx.stroke();
  };
  const isCanvasEmpty = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const pixelData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;

    // Check if all pixels are transparent
    for (let i = 0; i < pixelData.length; i += 4) {
      if (pixelData[i + 3] !== 0) { // Check alpha channel
        return false; // Not empty
      }
    }
    return true; // Canvas is empty
  };
  const stopDrawing = () => {
      const ctx = canvasRef.current.getContext('2d');
      ctx.closePath();
      setIsDrawing(false);
  };
  const handleConfirm = () => {
    console.log(isCanvasEmpty())
    if (isCanvasEmpty()) {
      uiNotificationService.show({
        title: 'Error',
        message: 'Please provide a signature before confirming.',
        type: 'error',
      });
      return; // Do not proceed if the canvas is empty
    }
    const canvas = canvasRef.current;
     const signatureData = canvas.toDataURL(); // Convert canvas to base64 image string
     onConfirm(signatureData); // Pass signature data to the main component
};
const clearCanvas = () => {
  const canvas = canvasRef.current;
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the entire canvas
};
  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <h2 className='mb-5 popup-heading'>Add Signature</h2>
        <p className='popup-para'>{message}</p>
        <canvas
          ref={canvasRef}
          onMouseDown={startDrawing}
          onMouseUp={stopDrawing}
          onMouseMove={draw}
          width={300}
          height={200}
          style={{ border: '1px solid black' }}
        ></canvas>
        <div className={`popup-actions text-left ${title && 'text-left'}`}>
          <button type="button" className="custom-button main-theme" onClick={handleConfirm}>Add</button>
          <button type="button"className="custom-button main-theme" onClick={clearCanvas}>Clear</button>
          <button type="button"className="custom-button" onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

export default SignaturePad;
